/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Public API for render
export { RenderComponentType, Renderer, RootRenderer } from './render/api';
//# sourceMappingURL=render.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/core/src/render.js
// module id = 439
// module chunks = 3